import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next'; // [!code ++]
import axios from 'common/AxiosAuth';
import { LargeButton, InfoMessage, DescriptionBar, MenuTab, Grid, Button } from 'components';
import { Message } from 'types/message';

import { InformationCircleOutlineIcon } from 'assets/svgs';
import UnPaidSchedule from './UnPaidSchedule';
import PaidSchedule from './PaidSchedule';

const MENU_INDEX = {
  PENDING: 0,
  COMPLETE: 1
};

const ManageS3 = () => {
  const { t } = useTranslation(); // [!code ++]
  const buttonMenuList = [t('manageS3.tabs.pending'), t('manageS3.tabs.complete')]; // [!code ++]
  const [selectedMenuIndex, setSelectedMenuIndex] = useState(MENU_INDEX.PENDING);
  const [messageArray, setMessageArray] = useState<Message[]>([]);
  const [messageArrayCount, setMessageArrayCount] = useState(0);
  function onClickTab(index: number) {
    setSelectedMenuIndex(index);
  }

  return (
    <div className="flex h-full w-full flex-col">
      <DescriptionBar
        className="md:px-6"
        title={t('manageS3.pageTitle')}
        description={t('manageS3.description')}
      />
      <div className="w-full flex-1 flex flex-col">
        <MenuTab menuList={buttonMenuList} selectedMenuIndex={selectedMenuIndex} onClickTab={onClickTab} />
        <div className="flex-1 flex flex-col px-6 py-6">
          {selectedMenuIndex === MENU_INDEX.PENDING && <UnPaidSchedule />}
          {selectedMenuIndex === MENU_INDEX.COMPLETE && <PaidSchedule />}
        </div>
      </div>
    </div>
  );
};

export default ManageS3;